import { useState } from 'react'
import styled from 'styled-components'

import Image from 'next/image'
import afterImage from '../../../../assets/homepage-v2/after.png'
import beforeImage from '../../../../assets/homepage-v2/before.png'

const Root = styled.div`
  position: relative;
  width: 100%;
  max-width: ${props => props.maxWidth || '720px'};
  aspect-ratio: ${props => props.aspectRatio || '550 / 410'};
  border-radius: 20px;
  overflow: hidden;
  margin: 0;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

const BeforeImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  // width: 300px;
`

const Img = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 550px 410px;
  background-repeat: no-repeat;
`

const Slider = styled.input`
  position: absolute;
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 100%;
  background: transparent;
  outline: none;
  margin: 0;
  cursor: ew-resize;
  z-index: 3;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 9px;
    height: 100vh;
    background: transparent;
    cursor: ew-resize;
  }

  &::-moz-range-thumb {
    width: 9px;
    height: 100vh;
    background: transparent;
    cursor: ew-resize;
    border: none;
  }
`

const SliderLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  background: white;
  pointer-events: none;
  transform: translateX(-50%);
  z-index: 2;
`

const SliderButton = styled.div`
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`

const SliderHandle = () => (
  <svg width="42" height="37" viewBox="0 0 42 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="20.848" cy="18.3049" rx="20.848" ry="18.3049" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.3622 12.4188C15.6802 12.698 15.6802 13.1508 15.3622 13.43L9.81959 18.2965L15.3622 23.1629C15.6802 23.4422 15.6802 23.8949 15.3622 24.1741C15.0441 24.4534 14.5285 24.4534 14.2105 24.1741L8.09204 18.8021C7.77401 18.5228 7.77401 18.0701 8.09204 17.7909L14.2105 12.4188C14.5285 12.1395 15.0441 12.1395 15.3622 12.4188Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M27.6378 12.4188C27.3198 12.698 27.3198 13.1508 27.6378 13.43L33.1804 18.2965L27.6378 23.1629C27.3198 23.4422 27.3198 23.8949 27.6378 24.1741C27.9559 24.4534 28.4715 24.4534 28.7895 24.1741L34.908 18.8021C35.226 18.5228 35.226 18.0701 34.908 17.7909L28.7895 12.4188C28.4715 12.1395 27.9559 12.1395 27.6378 12.4188Z" fill="black"/>
  </svg>
)

const maxValue = 200
const BeforeAfter = ({ maxWidth, aspectRatio, sliderLineWidth = 7, beforeSrc, afterSrc }) => {
  const [progress, setProgress] = useState(maxValue / 3.5)
  const position = (progress / maxValue) * 100
  const resolvedBefore = beforeSrc || beforeImage
  const resolvedAfter = afterSrc || afterImage
  const beforeImageUrl = typeof resolvedBefore === 'string' ? resolvedBefore : resolvedBefore.src

  const handleSlide = e => {
    setProgress(e.target.value)
  }

  return (
    <Root maxWidth={maxWidth} aspectRatio={aspectRatio}>
      <Image src={resolvedAfter} quality={100} layout="fill" objectFit="cover" priority />
      <BeforeImage
        style={{
          clipPath: `polygon(0px 0px, ${position}% 0px, ${position}% 100%, 0px 100%)`,
          backgroundImage: `url(${beforeImageUrl})`
        }}
      />
      <SliderLine style={{ left: `${position}%`, width: `${sliderLineWidth}px` }} />
      <Slider type="range" min="1" max={maxValue} value={progress} onChange={handleSlide} />
      <SliderButton style={{ left: `${position}%` }}>
        <SliderHandle />
      </SliderButton>
    </Root>
  )
}

export default BeforeAfter
